import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=cc0b3744&scoped=true"
import script from "./CartProduct.vue?vue&type=script&lang=js"
export * from "./CartProduct.vue?vue&type=script&lang=js"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=cc0b3744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b3744",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FixitDialog: require('/salonhomepage/client/components/FixitDialog.vue').default})
